__turbopack_context__.v({
  "chevron": "ViewLink-module__s6eBvG__chevron",
  "label": "ViewLink-module__s6eBvG__label",
  "viewLink": "ViewLink-module__s6eBvG__viewLink",
});
